import { IconButton, Tooltip, Zoom } from "@material-ui/core";
import React from "react";
import { Signal0, Signal1, Signal2, Signal3, Signal4 } from "App/Assets";

function WrapperNetworkAction({ stat, speed }) {
  let colors = "";
  switch (stat) {
    case true:
      switch (speed) {
        case "4g":
          colors = "#357a38";
          return (
            <>
              <Tooltip
                title='Terhubung | Sangat Cepat'
                aria-label='online'
                TransitionComponent={Zoom}
                arrow>
                <IconButton
                  style={{ padding: "0px" }}
                  aria-label='Network'
                  color='inherit'>
                  <Signal4 fill={colors} />
                </IconButton>
              </Tooltip>
            </>
          );
        case "3g":
          colors = "#cddc39";
          return (
            <>
              <Tooltip
                title='Terhubung | Cepat'
                aria-label='online'
                TransitionComponent={Zoom}
                arrow>
                <IconButton
                  style={{ padding: "0px" }}
                  aria-label='Network'
                  color='inherit'>
                  <Signal3 fill={colors} />
                </IconButton>
              </Tooltip>
            </>
          );
        case "2g":
          colors = "#ffc107";
          return (
            <>
              <Tooltip
                title='Terhubung | Lambat'
                aria-label='online'
                TransitionComponent={Zoom}
                arrow>
                <IconButton
                  style={{ padding: "0px" }}
                  aria-label='Network'
                  color='inherit'>
                  <Signal2 fill={colors} />
                </IconButton>
              </Tooltip>
            </>
          );
        case "slow-2g":
          colors = "#ff9800";
          return (
            <>
              <Tooltip
                title='Terhubung | Sangat Lambat'
                aria-label='online'
                TransitionComponent={Zoom}
                arrow>
                <IconButton
                  style={{ padding: "0px" }}
                  aria-label='Network'
                  color='inherit'>
                  <Signal1 fill={colors} />
                </IconButton>
              </Tooltip>
            </>
          );
        default:
          colors = "#e0e0e0";
          return (
            <>
              {/* <Tooltip
                  title={"Tidak Diketahui "}
                  aria-label="undifind"
                  TransitionComponent={Zoom}
                  arrow
                >
                  <IconButton
                    style={{ padding: "0px" }}
                    aria-label="Network"
                    color="inherit"
                  >
                    <Signal0 fill={colors} />
                  </IconButton>
                </Tooltip> */}
            </>
          );
      }
    default:
      colors = "#ff3d00";
      return (
        <>
          <Tooltip title='Terputus' aria-label='offline'>
            <IconButton
              style={{ padding: "0px" }}
              aria-label='Network'
              color='inherit'
              TransitionComponent={Zoom}
              arrow>
              <Signal0 fill={colors} />
            </IconButton>
          </Tooltip>
        </>
      );
  }
}

export default WrapperNetworkAction;
